<script>
import SelectWithSearch from "@/views/pages/Dilfoods/Common/SelectWithSearch.vue";
import { GravyPath } from '../../../../path';
import axios from "axios";
import Swal from "sweetalert2";
    export default {
        props : ['gravy','is_copy'],
        components : {SelectWithSearch},
        data(){
            return {
                baseUrl : process.env.VUE_APP_API_BACKEND_URL,
                transfer_to_gravy : null,
                transfer_date : null
            }
        },
        methods : {
            async saveData(){
                try {
                    let res;
                    if(this.is_copy == true){
                        res = await axios.post(this.baseUrl + GravyPath.GRAVY_COPY_TAGGING,{
                            transfer_from : this.gravy.id,
                            transfer_to : this.transfer_to_gravy,
                            transfer_date : this.transfer_date
                        });    
                    }else{
                        res = await axios.post(this.baseUrl + GravyPath.GRAVY_TRANSFER_TAGGING,{
                            transfer_from : this.gravy.id,
                            transfer_to : this.transfer_to_gravy,
                            transfer_date : this.transfer_date
                        });
                    }                    
                    if(res.data.status){
                        Swal.fire("Success","","success");
                    }else{
                        throw new Error(res.data.message);
                    }
                } catch (error) {
                    console.log(error);
                    Swal.fire(error.message,"","error");
                }
            }
        },
        computed : {
            GravyPath(){
                return GravyPath;
            }
        }
    }
</script>

<template>
    <b-card>
        <b-card-header>
            Gravy {{is_copy == true ? 'Copy' : 'Transfer'}} Tagging
        </b-card-header>
        <b-card-body>
            <b-row>
                <b-col sm="12">
                    <label>{{is_copy == true ? 'Copy' : 'Transfer'}} From</label>
                    <p>{{ gravy?.name }}</p>
                </b-col>
                <b-col sm="12">
                    <label>{{is_copy == true ? 'Copy' : 'Transfer'}} To</label>
                    <SelectWithSearch :search_api="GravyPath.SEARCH_GRAVIES" track_by="id" display="name"  @selectedOption="(v) => (transfer_to_gravy = v)"></SelectWithSearch>
                </b-col> 
                <b-col sm="12">
                    <label>{{is_copy == true ? 'Copy' : 'Transfer'}} Date</label>
                    <b-datepicker v-model="transfer_date"></b-datepicker>
                </b-col>                
            </b-row>
        </b-card-body>
        <b-card-footer>
            <b-button variant="success" @click="saveData">Save</b-button>
        </b-card-footer>
    </b-card>
</template>

<style>
    
</style>